import { useState, useCallback } from "react";
import { importHistoryStudentAPI } from "../../../hooks/importHistory/importHistoryStudentAPI";
import { ImportHistoryStudent } from "../../../hooks/importHistory/types/typesStudent";

interface ImportStatus extends ImportHistoryStudent {}

export function useImportHistory(token: string) {
  const [importHistory, setImportHistory] = useState<ImportStatus[]>([]);
  const [isFetchingHistory, setIsFetchingHistory] = useState<boolean>(false);

  const fetchImportHistory = useCallback(async () => {
    setIsFetchingHistory(true);
    try {
      const response = await importHistoryStudentAPI.getAll("", 1, token, 100);
      setImportHistory(response.import_histories);
    } catch (error) {
      console.error("Erro ao buscar históricos de importação:", error);
    } finally {
      setIsFetchingHistory(false);
    }
  }, [token]);

  return {
    importHistory,
    isFetchingHistory,
    fetchImportHistory,
    setImportHistory,
  };
}
